"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateWarehouse = exports.isWarehouse = exports.warehouseSchema = void 0;
var yup = require("yup");
var StoreWarning_1 = require("./StoreWarning");
var WarehousePathPoint_1 = require("./WarehousePathPoint");
var WarehousePickUpAddress_1 = require("./WarehousePickUpAddress");
exports.warehouseSchema = yup.object().shape({
    id: yup.string().required(),
    saleorWarehouseId: yup.string().required(),
    name: yup.string().required(),
    isDraft: yup.boolean().optional(),
    isPromotionStore: yup.boolean().optional(),
    isTemporarilyClosed: yup.boolean().optional(),
    closedUntil: yup.number().optional(),
    deliveryTime: yup.number().required(),
    path: yup.array().of(WarehousePathPoint_1.warehousePathPointSchema).required(),
    pathPoints: yup.array().of(WarehousePathPoint_1.warehousePathPointSchema).optional(),
    activePathId: yup.string().optional(),
    pickUpAddress: WarehousePickUpAddress_1.warehousePickUpAddressSchema.required(),
    banners: yup.array().of(yup.object()).optional(),
    areAppConfigBannersDisabled: yup.boolean().optional(),
    carousels: yup.array().of(yup.object()).optional(),
    countryId: yup.string().optional(),
    enabledSaleorCategoryIds: yup.array().of(yup.string()).optional(),
    trendingSearches: yup.array().of(yup.object()).optional(),
    warning: StoreWarning_1.storeWarningSchema.optional().default(undefined),
    riderTips: yup.array().of(yup.number()).optional(),
});
function isWarehouse(obj) {
    return exports.warehouseSchema.isValidSync(obj);
}
exports.isWarehouse = isWarehouse;
function validateWarehouse(obj) {
    return exports.warehouseSchema.validateSync(obj);
}
exports.validateWarehouse = validateWarehouse;
